// src/icons/svgs/info.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgInfo = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 36, height: 36, fill: "none", viewBox: "0 0 36 36", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18 31.5c7.456 0 13.5-6.044 13.5-13.5S25.456 4.5 18 4.5 4.5 10.544 4.5 18 10.544 31.5 18 31.5m0 1.5c8.284 0 15-6.716 15-15S26.284 3 18 3 3 9.716 3 18s6.716 15 15 15m.005-8a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1m0-13.997A1.5 1.5 0 1 1 18.006 14a1.5 1.5 0 0 1-.001-2.998", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgInfo);
var info_default = ForwardRef;
export {
  info_default as Info
};
